import * as Events from '@/constant/events'
export default {
  data() {
    return {
      dialog: {}
    }
  },
  methods: {
    setGlobalDialog(dialog) {
      if (!dialog) {
        this.$libTrack.error('弹窗配置为空')
        return
      }
      this.dialog = dialog || {}
    }
  },
  created() {
    Events.on(Events.GLOBAL_DIALOG, this.setGlobalDialog)
  },
  beforeDestroy() {
    Events.removeListener(Events.GLOBAL_DIALOG, this.setGlobalDialog)
  }
}
